









































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Button } from "vant";

Vue.use(Button);

@Component
export default class Index extends Vue {
  tosearch() {
    this.$router.replace({
      path: "/index",
      query: { type: this.$route.query.type, id: this.$route.query.id },
    });
  }
  created() {}
}
